import React from "react";
import LinkIcon from "./list/linkIcon";
import GithubIcon from "./list/github";
import VkIcon from "./list/vk";

const Icon = {
    link: LinkIcon,
    github: GithubIcon,
    vk: VkIcon
}

export default Icon;